module.exports = __webpack_public_path__ + "img/Medical Stuff.ecdfa4b9.svg";